import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { getIconComponent } from "@/assets/icons";

export interface IconProps extends SvgIconProps {
  type: string;
  name: string;
}

export const Icon: React.FC<IconProps> = ({ type, name, ...props }) => {
  const IconComponent = getIconComponent(type, name);
  return <SvgIcon component={IconComponent} inheritViewBox {...props} />;
};
